import React, { useState } from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { Formik } from "formik";
import * as YUP from "yup";
import CreatableSelect from "react-select/creatable";
import { Col, Row } from "react-bootstrap";
import * as icons from "@material-ui/icons";


const WorkerSelection = (props) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState(props.values.neededWorkerList);


  const initialValues = {
    vocationTags: {},
    requestedWorkerCount: 0,
  };

  const validationSchema = YUP.object({});

  const onSubmit = (values, { resetForm }) => {
    var xx = rows;
    xx.push({
      ...values, 
      vocationTags: values.vocationTags.label,
    });
    setRows(xx);
    props.setFieldValue("neededWorkerList", rows);
    resetForm();
  };
  const onDelete = (vocationTags) => {
    console.log(rows);
    console.log(props.values.neededWorkerList);
    console.log(vocationTags);
    const newRows = rows.filter((xx) => xx.vocationTags !== vocationTags);
    props.setFieldValue("neededWorkerList", newRows);
    setRows(newRows);
  };

  return (
    <core.Card>
      <core.CardHeader
        title={t("pages.workrequest.workerSelection.stepname")}
      />
      <core.Divider />
      <core.CardContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue,
          }) => (
            <core.Container>
              <Row className="justify-content-md-center">
                <Col md={3} xs={12}></Col>
                <Col md={6} xs={12}>
                  <core.Grid container spacing={1}>
                    <core.Grid item md={12} xs={12}>
                      <CreatableSelect
                        fullWidth
                        isClearable
                        name="vocationTags"
                        placeholder="Tag"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={values.vocationTags}
                        onChange={(newValue, actionMeta) =>
                          setFieldValue("vocationTags", newValue)
                        }
                        options={props.tagList}
                      />
                    </core.Grid>

                    <core.Grid item md={12} xs={12}>
                      <core.TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        label={t("workerRequest.requestedWorkerCount")}
                        name="requestedWorkerCount"
                        type="number"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size="small"
                        variant="outlined"
                        value={values.requestedWorkerCount}
                      />
                    </core.Grid>

                    <core.Grid item md={12} xs={12}>
                      <core.Box display="flex" justifyContent="center">
                        <core.Button
                          variant="outlined"
                          color="secondary"
                          startIcon={<AddBoxIcon />}
                          onClick={handleSubmit}
                        >
                          Add
                        </core.Button>
                      </core.Box>
                    </core.Grid>
                  </core.Grid>
                </Col>
                <Col md={3} xs={12}></Col>
              </Row>
              <Row>
                <core.TableContainer component={core.Paper}>
                  <core.Table aria-label="simple table">
                    <core.TableHead>
                      <core.TableRow>
                        <core.TableCell>
                          {t("workerRequest.vocationTags")}
                        </core.TableCell>
                        <core.TableCell>
                          {t("workerRequest.requestedWorkerCount")}
                        </core.TableCell>
                      </core.TableRow>
                    </core.TableHead>

                    <core.TableBody>
                      {props.values.neededWorkerList?.map((row) => (
                        <core.TableRow key={row.vocationTags}>
                          <core.TableCell>{row.vocationTags}</core.TableCell>
                          <core.TableCell>
                            {row.requestedWorkerCount}
                          </core.TableCell>
                          <core.TableCell> 
                              <core.IconButton aria-label="delete" onClick={() => onDelete(row.vocationTags)}><icons.Delete/></core.IconButton>
                            </core.TableCell>
                        </core.TableRow>
                      ))}
                    </core.TableBody>
                  </core.Table>
                </core.TableContainer>
              </Row>
            </core.Container>
          )}
        </Formik>
      </core.CardContent>
      <>
        {/* Master state
        <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
      </>
    </core.Card>
  );
};

export default WorkerSelection;
